import {
	LANGUAGE_LOCALES_CODE as _LANGUAGE_LOCALES_CODE,
	PRODUCT_REGULAR_HANGING as _PRODUCT_REGULAR_HANGING,
	PRODUCT_LIGHTING_ATTRIBUTES as _PRODUCT_LIGHTING_ATTRIBUTES,
	PRODUCT_POWER_ATTRIBUTES as _PRODUCT_POWER_ATTRIBUTES,
	PRODUCT_LENGTH_ATTRIBUTES as _PRODUCT_LENGTH_ATTRIBUTES
} from "@front/constants/uiConstants"

export const THEMES = ['light', 'dark']
export const DEFAULT_THEME = 'light'
export const DEFAULT_CATALOG = 16
export const DEFAULT_LANGUAGE = 'en'
export const COOKIE_AUTH_TOKEN = 'vibia_jwt'
export const COOKIE_AUTH_REFRESH = 'vibia_refresh'
export const COOKIE_LANGUAGE_KEY = '__language'
export const COOKIE_CATALOG_ID_KEY = '__catalogId'
export const COOKIE_CATALOG_NAME_KEY = '__catalog'
// Cookie de tema compartida con la professional-area nueva (app2.*). Misma cookie, mismos valores
// crudos (`white`/`black`/`system`) y mismo dominio padre → el tema es coherente entre subdominios.
export const COOKIE_THEME_KEY = 'theme_vibia'
export const THEME_PREFERENCES = ['white', 'black', 'system']
export const DEFAULT_THEME_PREFERENCE = 'system'
export const DOMAIN_PUBLIC = '.vibia.com'
export const TEXT_REGEX = /^(\w|\s|[-_'&()+À-ÿ])*$/
export const TEXTAREA_REGEX = /^(\w|\s|[.,:-_'&()À-ÿ])*$/
export const POSTAL_CODE_REGEX = /(.+|.?)/
export const DEFAULT_PRODUCT_IMAGE = process.env.PUBLIC_URL + '/images/no_image_available-01.svg'

// Los valores usan `var(--np-c-*, <hex legacy>)`: cuando el contenido se renderiza dentro del
// shell nuevo (`.emulate-new-menu`, toggle emulateNewMenuProfessional on) los tokens se redefinen
// con el palette del design system (ver assets/scss/_new-pro-menu.scss). Con el toggle off no hay
// ancestro que los defina → cae al hex legacy (regresión cero). Solo en claro; el dark cae a legacy.
export const COLORS = {
	primaryLima: 'var(--np-c-primary-lima, #dceb00)',
	primaryPink: '#dba89b',
	secondaryLima: '#cdd72b',
	secondaryPink: '#ddd9d2',
	lightRed: '#f3dcd6',
	gray1: 'var(--np-c-gray-1, #424b5a)',
	gray2: 'var(--np-c-gray-2, #8994a5)',
	gray3: 'var(--np-c-gray-3, #bec9da)',
	gray4: 'var(--np-c-gray-4, #eeeeee)',
	gray5: 'var(--np-c-gray-5, #f7f7f7)',
	gray6: 'var(--np-c-gray-6, #d8d8d84d)',
	white: 'var(--np-c-white, #fff)',
	black: 'var(--np-c-black, #000)',
	success: '#7ed67a',
	error: '#f56e6e',
	warning: '#ffc108'
}

// Palette espejo del área profesional nueva (@vibialighting/ui), para usos en estilos inline.
// Solo aplica bajo el toggle emulateNewMenuProfessional. Ver assets/scss/_new-pro-menu.scss.
export const NEW_PRO_MENU_COLORS = {
	bg: '#fcfbfc',
	fg: '#010101',
	bgHover: '#f6f2f0',
	border: '#e1dbd3',
	muted: '#807c7e',
	accent: '#912f2a'
}

export const PRODUCT_REGULAR_ATTRIBUTES = ['finish', 'ledColourTemp', 'control', 'installation']
export const PRODUCT_STANDARD_ATTRIBUTES = ['finishingType', 'colourTempLED', 'control', 'installationType']
export const PRODUCT_REGULAR_HANGING = _PRODUCT_REGULAR_HANGING
export const PRODUCT_LENGTH_ATTRIBUTES = _PRODUCT_LENGTH_ATTRIBUTES
export const PRODUCT_LIGHTING_ATTRIBUTES = _PRODUCT_LIGHTING_ATTRIBUTES
export const PRODUCT_POWER_ATTRIBUTES = _PRODUCT_POWER_ATTRIBUTES

export const MAX_CHARACTERS_ALLOWED = {
	PROJECT_TITLE: 50,
	INPUT_TEXTAREA: 4000,
	INPUT_EMAILS: 248,
	PROJECT_VERSION_TITLE: 30
}

export const CATALOG_NAMES = {
	16: 'INT',
	21: 'USA'
}

export const LANGUAGE_CODES = {
	american: 'us',
	english: 'en',
	french: 'fr',
	german: 'de',
	italian: 'it',
	spanish: 'es'
}

export const LANGUAGE_CODES_LOCALE = {
	us: 'en-US',
	en: 'en',
	fr: 'fr',
	de: 'de',
	it: 'it',
	es: 'es'
}

export const LANGUAGE_LOCALES_CODE = _LANGUAGE_LOCALES_CODE

export const CONFIGURATOR_ID = {
	CREA: 1,
	DRAWING: 2,
	NODRAWING: 3,
	EXPRESS: 4,
	COMPOSITOR: 5,
	ATTRIBUTES_CONFIGURATOR: 6,
}

export const SUBFAMILY_ID = {
	STICKS: 219,
	PLUSMINUS: 225
}

export const USER_TYPES = {
	0: 'none',
	1: 'particular',
	2: 'professional'
}

export const USER_ROLES = {
	webUser: {
		id: 1,
		name: 'webUser'
	},
	specifier: {
		id: 2,
		name: 'specifier'
	},
	specifier_usa: {
		id: 6,
		name: 'specifierUsa',
	},
	distributor: {
		id: 3,
		name: 'distributor'
	},
	sales: {
		id: 4,
		name: 'sales',
		catalogId: 16
	},
	sales_usa: {
		id: 7,
		name: 'sales',
		catalogId: 21
	},
	importer: {
		id: 8,
		name: 'importer'
	},
	admin: {
		id: 9,
		name: 'admin'
	},
	apiUser: {
		id: 10,
		name: 'apiUser'
	}
}

export const SEARCH = {
	de: 'suchen',
	es: 'buscar',
	fr: 'chercher',
	it: 'cerca',
	en: 'search',
	us: 'search',
}

export const IGNORED_COLLECTION_APPLICATIONS = {
	225: [4, 5, 6]
}

export const CONFIGURATOR_TYPES = {
	TOOLKIT: 6
}

